module.exports = __webpack_public_path__ + "media/12.81adfccc.wav";